import { render, staticRenderFns } from "./cEventsGatewayLog.vue?vue&type=template&id=58c4da0e&scoped=true"
import script from "./cEventsGatewayLog.vue?vue&type=script&lang=js"
export * from "./cEventsGatewayLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58c4da0e",
  null
  
)

export default component.exports